(() => {
  const roots = document.querySelectorAll('[data-swm26-termine]');
  if (!roots.length) return;

  const parseJSON = (el, fallback) => {
    try { return el ? JSON.parse(el.textContent || '') : fallback; } catch { return fallback; }
  };

  const formatMoney = (cents, formatStr) => {
    const fmt = formatStr || '{{amount}}';
    const value = (Number(cents || 0) / 100).toFixed(2);
    const parts = value.split('.');
    const withComma = `${parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${parts[1]}`;

    if (fmt.includes('{{amount_no_decimals}}')) return fmt.replace('{{amount_no_decimals}}', parts[0]);
    if (fmt.includes('{{amount_with_comma_separator}}')) return fmt.replace('{{amount_with_comma_separator}}', withComma);
    if (fmt.includes('{{amount}}')) return fmt.replace('{{amount}}', withComma);
    return withComma;
  };

  const dispatchAll = (el) => {
    if (!el) return;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const norm = (s) => (typeof s === 'string' ? s.trim() : s);

  const getSelectedOptions = (root) => {
    const fieldsets = Array.from(root.querySelectorAll('[data-swm26-opt]'));
    return fieldsets.map((fs) => {
      let checked = fs.querySelector('input[data-swm26-opt-radio]:checked');
      if (!checked) checked = fs.querySelector('input[data-swm26-opt-radio][checked]');
      return checked ? norm(checked.value) : null;
    });
  };

  const findVariantByOptions = (variants, options) => {
    return variants.find((v) => {
      if (options[0] && norm(v.option1) !== options[0]) return false;
      if (options[1] && norm(v.option2) !== options[1]) return false;
      if (options[2] && norm(v.option3) !== options[2]) return false;
      return true;
    });
  };

  // === The key: find the REAL product form (unique + stable) ===
  const getProductForm = () => document.querySelector('form[action*="/cart/add"]');

  const getMainScope = () => {
    const form = getProductForm();
    if (!form) return null;
    // Shopify section wrapper if present, else use form parent
    return form.closest('[id^="shopify-section-"]') || form.parentElement || document;
  };

  const clickThemeOptionRadio = (scope, optionValue) => {
    const wanted = norm(optionValue);
    const radios = Array.from(
      scope.querySelectorAll('options-selection input[type="radio"][data-variant-option-value]')
    );
    const match = radios.find((r) => norm(r.value) === wanted);
    if (!match) return false;

    try { match.click(); } catch {}
    match.checked = true;
    dispatchAll(match);
    return true;
  };

const setVariantIdInScope = (scope, variantId) => {
  const id = String(variantId);
  if (!scope) return false;

  // A) The hidden select used by PixelUnion / OOTS (often outside the <form>)
  scope.querySelectorAll('select[name="id"], select[data-variants][name="id"]').forEach((sel) => {
    sel.value = id;
    dispatchAll(sel);
  });

  // B) Any hidden inputs named id (sometimes used instead of select)
  scope.querySelectorAll('input[name="id"]').forEach((inp) => {
    inp.value = id;
    dispatchAll(inp);
  });

  // C) The actual /cart/add form input if present
  scope.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((inp) => {
    inp.value = id;
    dispatchAll(inp);
  });

  // D) Update theme component attribute
  const vs = scope.querySelector('variant-selection[variant]');
  if (vs) vs.setAttribute('variant', id);

  return true;
};

  const syncVariantIntoOldModule = (root, variantId) => {
    const scope = getMainScope();
    if (!scope) {
      console.warn('[SWM26 Termine] No /cart/add form found. Product information section is missing.');
      return false;
    }

    const variants = parseJSON(root.querySelector('[data-swm26-variants]'), []);
    const vObj = variants.find((v) => String(v.id) === String(variantId));

    // Drive theme state via radio click first (if present)
    if (vObj?.option1) clickThemeOptionRadio(scope, vObj.option1);

    // Then force id into form
    setVariantIdInScope(scope, variantId);


    return true;
  };

  const findServicifyButton = (productId) => {
    const scope = getMainScope();

    // Prefer inside old module scope
    if (scope && productId) {
      const byProduct = scope.querySelector(
        `#digital-appointments-select-time-btn[data-servicify-product="${productId}"] .servicify-select-a-time-button`
      );
      if (byProduct) return byProduct;
    }
    if (scope) {
      const inScope = scope.querySelector('.servicify-select-a-time-button');
      if (inScope) return inScope;
    }

    // Fallback global (keeps popup working)
    if (productId) {
      const byProductGlobal = document.querySelector(
        `#digital-appointments-select-time-btn[data-servicify-product="${productId}"] .servicify-select-a-time-button`
      );
      if (byProductGlobal) return byProductGlobal;
    }
    return document.querySelector('.servicify-select-a-time-button');
  };

  const waitForServicifyButton = (productId, timeoutMs = 6000) =>
    new Promise((resolve) => {
      const existing = findServicifyButton(productId);
      if (existing) return resolve(existing);

      const start = Date.now();
      const obs = new MutationObserver(() => {
        const btn = findServicifyButton(productId);
        if (btn) {
          obs.disconnect();
          resolve(btn);
        } else if (Date.now() - start > timeoutMs) {
          obs.disconnect();
          resolve(null);
        }
      });

      obs.observe(document.documentElement, { childList: true, subtree: true });
    });

  roots.forEach((root) => {
    const variants = parseJSON(root.querySelector('[data-swm26-variants]'), []);
    const moneyFmt = parseJSON(root.querySelector('[data-swm26-money-format]'), '{{amount}}');
    const priceEl = root.querySelector('[data-swm26-price]');
    const dateBtn = root.querySelector('[data-swm26-termine-datebtn]');
    const productId = root.getAttribute('data-product-id');

    const sync = () => {
      if (!variants.length) return null;

      const opts = getSelectedOptions(root);
      const v = findVariantByOptions(variants, opts);
      if (!v) return null;

      // Update UI labels
      root.querySelectorAll('[data-swm26-opt]').forEach((fs, idx) => {
        const out = fs.querySelector('[data-swm26-opt-value]');
        if (out) out.textContent = opts[idx] || '';
      });

      // Update displayed price in new module
      if (priceEl) priceEl.textContent = formatMoney(v.price, moneyFmt);

      // Sync into old module (product form)
      syncVariantIntoOldModule(root, v.id);

      return v;
    };

    root.addEventListener('change', (e) => {
      if (e.target && e.target.matches && e.target.matches('input[data-swm26-opt-radio]')) {
        sync();
      }
    });

dateBtn?.addEventListener('click', async (e) => {
  e.preventDefault();

  const v = sync();
  if (!v) return;

  // 1) Ensure variant is synced into the real product form
  syncVariantIntoOldModule(root, v.id);

  // 2) Re-run Servicify scoped to the product form area (forces it to use the right variant)
  const scope = getMainScope();
  if (window.Servicify && typeof window.Servicify.run === 'function' && scope) {
    try {
      await window.Servicify.run({
        productId: Number(productId),
        variantId: Number(v.id),
        parentElement: scope, // <-- key: bind to product form section, not cart drawer
      });
    } catch (err) {
      console.warn('[SWM26 Termine] Servicify.run failed', err);
    }
  } else {
    console.warn('[SWM26 Termine] Servicify.run not available or no scope');
  }

  // 3) Click the servicify button (prefer inside scope)
  const btnInScope =
    scope?.querySelector(
      `#digital-appointments-select-time-btn[data-servicify-product="${productId}"] .servicify-select-a-time-button`
    ) || scope?.querySelector('.servicify-select-a-time-button');

  if (btnInScope) {
    btnInScope.click();
    return;
  }

  // fallback global
  const btn = await waitForServicifyButton(productId, 6000);
  if (btn) btn.click();
  else console.warn('[SWM26 Termine] Servicify button not found');
});


    sync();
  });
})();
